import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-compact-up', 'ChevronCompactUp', [["path",{"d":"M4 13l8 -3l8 3"}]]);